import * as React from 'react';

import { getLocale } from '@rematter/common/locale';
import { BillRecord } from '@rematter/modules/finance/types';
import { formatMoney, GroupRow, Row } from '@rematter/ui-web';

import { useTranslations } from '../../i18n/useTranslations';

type Props = GroupRow<BillRecord>;

//
// ⚛️ ⚛️ ⚛️ BILL GROUP CELL ⚛️ ⚛️ ⚛️
//
export const BillGroupCell: React.FC<Props> = ({ children }) => {
  // Translations
  const t = useTranslations();

  const accountName =
    children[0]?.accountName || t.bills.list.groupHeader.unknownAccount;
  const billCount = children.length;
  const pendingTotal = children
    .filter((bill) => bill.status === 'Pending')
    .reduce((sum, bill) => sum + bill.amount.amount, 0);
  const currencyCode = children[0]?.amount.currencyCode;
  const formattedTotal =
    currencyCode && pendingTotal !== 0
      ? formatMoney(pendingTotal, currencyCode, getLocale())
      : '';

  return (
    <Row gap3 className="@BillGroupCell font-medium">
      <span>{accountName}</span>
      <Row gap1 className="text-sm font-normal text-neutral/50">
        &bull;
        <span>{t.bills.list.groupHeader.billCount(billCount)}</span>
        {formattedTotal && (
          <>
            &bull;
            <span>{t.bills.list.groupHeader.outstanding(formattedTotal)}</span>
          </>
        )}
      </Row>
    </Row>
  );
};
